export default "__VITE_ASSET__CHpuVIKK__"